import { FuncaoParticipante, GrupoAcesso, Perfil, RegistroStatus } from 'common/genericTypes';
import { StatusToast } from 'components/validation/statusToast';
import { Button, MdSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootState } from 'store';
import { CredenciadoListItem } from 'components/credenciado/credenciadoListItem';
import { CredenciadosResponse } from 'store/modules/credenciados/credenciadosReponse';
import {
  ValidationCredenciadoDrawer,
  ValidationCredenciadoRequestKind,
} from 'components/validation/validationCredenciadoDrawer';
import { addAlert } from 'store/modules/snackBar';
import { statusFormularioDescriptions } from 'common/genericDescriptions';
import {
  DocumentsCredenciadoDrawer,
  DocumentsCredenciadoRequestKind,
} from 'components/validation/documentsCredenciadoDrawer';

const Credenciados: React.FC = () => {
  const getCredenciadosList = useSelector((state: RootState) => state.credenciadoApi.getCredenciados);
  const patchAprovarOuReprovarCredenciamentoEmissor = useSelector(
    (state: RootState) => state.credenciadoApi.patchAprovarOuReprovarCredenciamentoEmissor
  );
  const getCredenciado = useSelector((state: RootState) => state.credenciadoApi.getByIdCredenciado);
  const isUsuarioOperacoes = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes
  );
  const isUsuarioCadastro = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.CadastroOperacoes
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [credenciados, setCredenciados] = useState<CredenciadosResponse[]>([]);
  const [openValidationDrawer, setOpenValidationDrawer] = useState<boolean>(false);
  const [openDocumentDrawer, setOpenDocumentDrawer] = useState<boolean>(false);
  const [checked, setChecked] = useState<string>();
  const [checkedStatus, setCheckedStatus] = useState<RegistroStatus>();
  const [reject, setReject] = useState<boolean>(false);
  const [lastCredenciadoValidated] = useState<string>();
  const [checkedCredenciado, setCheckedCredenciado] = useState<CredenciadosResponse>();
  const [submitting] = useState<boolean>(false);
  const [credenciadoDocument, setCredenciadosDocument] = useState<CredenciadosResponse>();

  async function getCredenciadoDocument(credenciado: CredenciadosResponse) {
    try {
      const response = await getCredenciado(dispatch, credenciado?.credenciadoEmissorGuid ?? '', true);
      setCredenciadosDocument(response.data);
      setOpenDocumentDrawer(true);
    } catch (error) {}
  }

  const getCredenciados = useCallback(async () => {
    try {
      const result = await getCredenciadosList(dispatch, true);
      setCredenciados(result.data);
    } catch (error) {}
  }, [dispatch, getCredenciadosList]);

  useEffect(() => {
    getCredenciados();
  }, [getCredenciados]);

  const handleValidation = async (id: string, status: RegistroStatus, justification: string) => {
    try {
      await patchAprovarOuReprovarCredenciamentoEmissor(dispatch, id, { status: status, justificativa: justification });
      dispatch(
        addAlert({
          message: `Credenciamento ${statusFormularioDescriptions[status]} com sucesso!`,
          severity: 'success',
        })
      );
      getCredenciados();
    } catch (error) {}
  };

  const handleValidationClick = (reject: boolean) => () => {
    setReject(reject);
    setOpenValidationDrawer(true);
    setChecked('');
  };

  return (
    <>
      <MdSpace />
      {checkedStatus && (
        <>
          <StatusToast
            status={checkedStatus}
            ticket={lastCredenciadoValidated ?? ''}
            onDismiss={() => setCheckedStatus(undefined)}
          />
          <MdSpace />
        </>
      )}
      {credenciados?.map((credenciado) => (
        <CredenciadoListItem
          key={credenciado.id}
          credenciado={credenciado}
          checked={checked === credenciado.id.toString()}
          documentOpen={openDocumentDrawer}
          disabled={credenciado?.status !== RegistroStatus.EmAnalise}
          onDetailsEmissorButtonClick={
            isUsuarioOperacoes || isUsuarioCadastro
              ? () => history.push(`/gerenciar/participantes/detalhes/${credenciado.emissorId}`)
              : undefined
          }
          onDetailsCredenciadoButtonClick={
            isUsuarioOperacoes || isUsuarioCadastro
              ? () => history.push(`/gerenciar/participantes/detalhes/${credenciado.credenciadoId}`)
              : undefined
          }
          onDocumentClick={
            isUsuarioOperacoes || isUsuarioCadastro ? () => getCredenciadoDocument(credenciado) : undefined
          }
        />
      ))}
      <MdSpace />

      <DocumentsCredenciadoDrawer
        credenciado={credenciadoDocument}
        kind={DocumentsCredenciadoRequestKind.CREDENCIADO}
        opened={openDocumentDrawer}
        onClose={() => setOpenDocumentDrawer(false)}
        disableButtons={submitting}
      />

      <ValidationCredenciadoDrawer
        kind={ValidationCredenciadoRequestKind.CREDENCIADO}
        credenciado={checkedCredenciado}
        opened={openValidationDrawer}
        onClose={() => setOpenValidationDrawer(false)}
        reject={reject}
        onSubmit={handleValidation}
        disableButtons={submitting}
      />
    </>
  );
};

export default Credenciados;
